import type { SerializedError } from "@reduxjs/toolkit";

import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import initialConfig from "../initialConfig";

const initialState = {
  updateUserPaymentData: {},
  updateUserPaymentLoading: false,
  updateUserPaymentError: null as SerializedError | null,
};

interface IUpdateUserPaymentInput {
  name: string;
  surname: string;
  identificationNumber: string;
  city: string;
  email: string;
  ip: string;
  description: string;
  postcode: string;
  accessToken: string;
}


export const updateUserPaymentFunc = createAsyncThunk("updateUserPayment/updateUserPaymentFunc", async (values : IUpdateUserPaymentInput) => {


  const data1 = JSON.stringify({
    query: `mutation Self_updateUserBillingInfo($input: BillingInfoInput!) {
      self_updateUserBillingInfo(input: $input) {
        success
      }
    }`,
    variables: {
      "input": {
        "buyer": {
          "name": values.name,
          "surname": values.surname,
          "identityNumber": values.identificationNumber,
          "city": values.city,
          "country": "Türkiye",
          "email": values.email,
          "ip": values.ip,
          "registrationAddress": values.description
        },
        "billingAddress": {
          "fullName": values.name + " " + values.surname,
          "email": values.email,
          "address1": values.description,
          "postcode": values.postcode || "0",
          "country" : "Türkiye",
          "city": values.city
        },
        "shippingAddress": {
          "fullName": values.name + " " + values.surname,
          "email": values.email,
          "address1": values.description,
          "postcode": values.postcode || "0",
          "country" : "Türkiye",
          "city": values.city
        }
      }
    }

  });

  const config = initialConfig('https://api.hophop.com.tr/payment/graphql', data1, values.accessToken);

  const response = axios(config).then((res) => {
    const data = res.data;
    return data;
  }).catch((err) => err);

  const data = await response;
  return data;
});


const updateUserPayment = createSlice({
  name: "updateUserPayment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateUserPaymentFunc.pending, (state) => {
      state.updateUserPaymentLoading = true;
    });
    builder.addCase(updateUserPaymentFunc.fulfilled, (state, action) => {
      state.updateUserPaymentLoading = false;
      state.updateUserPaymentData = action.payload?.data?.self_updateUserBillingInfo?.success;
      state.updateUserPaymentError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(updateUserPaymentFunc.rejected, (state, action) => {
      state.updateUserPaymentLoading = false;
      state.updateUserPaymentError = action.error;
    });
  }
});

export default updateUserPayment.reducer;